// fiscalYear.js — iter180l
// JS mirror of backend services/fiscal_year.py. SINGLE SOURCE OF TRUTH for
// April-March fiscal year math in the UI. Never use Jan-Dec semantics.

export const FY_START_MONTH = 4;

export const FY_QUARTERS = {
  1: [4, 5, 6],
  2: [7, 8, 9],
  3: [10, 11, 12],
  4: [1, 2, 3], // calendar months belonging to FY-prev-year
};

export function fyStartYearFor(year, month) {
  return month >= FY_START_MONTH ? year : year - 1;
}

export function fyLabel(fyStartYear) {
  return `${fyStartYear}-${String(fyStartYear + 1).slice(-2)}`;
}

export function quarterOfMonth(month) {
  for (const q of [1, 2, 3, 4]) {
    if (FY_QUARTERS[q].includes(month)) return q;
  }
  throw new Error(`Invalid month: ${month}`);
}

export function monthsInQuarter(fyStartYear, quarter) {
  const months = FY_QUARTERS[quarter];
  const cy = quarter <= 3 ? fyStartYear : fyStartYear + 1;
  return months.map((m) => [cy, m]);
}

export function fyQuarterLabel(fyStartYear, quarter) {
  const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const ms = FY_QUARTERS[quarter];
  return `FY ${fyLabel(fyStartYear)} Q${quarter} (${names[ms[0] - 1]}-${names[ms[ms.length - 1] - 1]})`;
}

export function fyYtdLabel(fyStartYear, throughMonth) {
  const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `YTD FY ${fyLabel(fyStartYear)} (Apr → ${names[throughMonth - 1]})`;
}

export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Returns the (year, month) tuple of the FY's first month (always April).
 *  Convenience for the date pickers. */
export function fyFirstMonth(fyStartYear) {
  return [fyStartYear, 4];
}

/** A set of FY start years to populate dropdowns. Goes back 3 years, fwd 1. */
export function fyChoices(currentYear, currentMonth) {
  const center = fyStartYearFor(currentYear, currentMonth);
  return [center - 3, center - 2, center - 1, center, center + 1];
}
